import { render, staticRenderFns } from "./TemplateModal.vue?vue&type=template&id=56f9513c"
import script from "./TemplateModal.vue?vue&type=script&lang=ts"
export * from "./TemplateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports